<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-26 15:59:08
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-02-21 08:51:58
 * @Description: 动态共享详情页
-->
<template>
  <div class="case-share-list">
    <!-- 详情页头部 -->
    <detail-header
      title="动态共享"
      icon="icon-fenxiang"
      :iconStyle="iconStyle"
      :tip="caseShareTips"
      @back="back"
    ></detail-header>
    <div class="container-body" v-loading="data.isLoading">
      <!-- 详情页表单 -->
      <detail-form
        :showPublishButton="true"
        :showReviewButton="deptPower"
        :showNewArticle="true"
        @search="handleClickSearch"
        @showTypeQuery="showTypeQuery"
      ></detail-form>

      <div class="table-card">
        <detail-table
          :data="tableData"
          :columns="tableColumns"
          height="calc(100vh - 380px)"
          :header-cell-style="headerCellStyle"
          :row-style="tableRowClassName"
          :showBorder="false"
          showOperator
          operatorWidth="150"
          @sort-change="sort_change"
        >
          <template #createTm="{scope}">
            <span>{{ scope.row.createTm | dateFormat }}</span>
          </template>
          <template #status="{scope}">
            <span>{{ scope.row.status | computedArticleStatus }}</span>
          </template>
          <template #totalAttaSize="{scope}">
            <span>{{ scope.row.totalAttaSize | fileSizeUnit }}</span>
          </template>

          <template #departmentName="{scope}">
            <span v-if="scope.row.tp == '6'">{{ scope.row.pName }}</span>
            <span v-else>{{ scope.row.departmentName }}</span>
          </template>

          <!-- 操作 -->
          <template #default="{scope}">
            <button
              v-if="showDataType === '1'"
              type="button"
              class="eims-button"
              @click.stop="caseShareFilePrev(scope.row)"
            >
              查看
            </button>
            <button
              v-else
              type="button"
              class="eims-button"
              @click.stop="caseShareFilePrev(scope.row)"
            >
              预览
            </button>

            <button
              type="button"
              v-if="computedShowEdit(scope.row)"
              class="eims-button"
              @click.stop="handleEditCaseShare(scope.row)"
            >
              编辑
            </button>
            <button
              type="button"
              v-if="computedShowDelete(scope.row) && scope.row.status !== '1'"
              class="eims-button"
              @click.stop="caseShareDelete(scope.row)"
            >
              删除
            </button>
          </template>
        </detail-table>
      </div>

      <span class="page">
        <el-pagination
          layout="sizes, prev, pager, next"
          :total="data.list.length"
          :page-size="data.pageSize"
          :current-page="data.pageNum"
          :page-sizes="data.pageSizeArray"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </span>
    </div>

    <post-create
      title="发布动态共享"
      :hasAttachment="true"
      :hasCaseShare="true"
      :visible.sync="postCreateVisible"
      :tips="caseShareTips"
      :baseUrl="baseUrl"
      @handlerVisible="handlerVisible"
      @sensitiveWord="sensitiveWord"
      @refresh="queryData"
    />

    <post-detail
      v-if="postDetailVisible"
      :baseUrl="baseUrlDetail"
      :post-code="dialog.postCode"
      @handlerVisible="handlerVisible"
    />

    <post-update
      v-if="postUpdateVisible"
      :hasAttachment="true"
      :hasCaseShare="true"
      :post-code="dialog.postCode"
      :post-tp-code="dialog.postTpCode"
      :status="dialog.status"
      :baseUrl="baseUrlDetail"
      :baseUrlUpdate="baseUrlUpdate"
      @handlerVisible="handlerVisible"
      @sensitiveWord="sensitiveWord"
      @refresh="queryData"
    />

    <post-approve
      :row="dialog"
      :visible.sync="postApproveVisible"
      :btnFlag="deptPower"
      @refresh="queryData"
    ></post-approve>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { mapState } from "vuex";
import { Message } from "element-ui";
import {
  ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
  SINGLE_ATTACHMENT_MAX_SIZE,
  PAGE_SIZE_ARRAY
} from "@/constants/constants";
import animation from "@/components/loading/animation";
import PostCreate from "@/components/detail/PostCreate";
import PostDetail from "@/components/detail/PostDetail";
import PostUpdate from "@/components/detail/PostUpdate";
import PostApprove from "@/components/detail/PostApprove";
import DetailHeader from "@/components/common/DetailHeader";
import DetailForm from "@/components/common/DetailForm";
import DetailTable from "@/components/common/DetailTable";
import { articleMixin } from "../mixins/articleMixin";
export default {
  name: "CaseShareList",
  components: {
    PostApprove,
    PostDetail,
    animation,
    PostCreate,
    PostUpdate,
    DetailHeader,
    DetailForm,
    DetailTable
  },
  mixins: [articleMixin],
  data() {
    return {
      //搜索的时候显示的列表数据
      searchPublishVisible: false,
      //未审核的 (管理员可以查看的)
      unApprovePublishVisible: false,
      //显示我发布的
      oneSelfPublishVisible: false,
      //默认显示的文章
      allPublishVisible: true,
      //显示文章的类型 -1全部 0我发布的 1待审核的 2搜索的
      showDataType: "-1",
      overturnAnimation: null,
      this_: this, //保存this以便filters中使用
      //true是结束,false是正在处理
      attachmentUploadState: true,
      //true是结束,false是正在处理
      formInfoSaveState: true,
      //附件的允许上传的类型
      acceptAttachmentType: ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
      //单个附件的最大的大小
      singleAttachmentSize: SINGLE_ATTACHMENT_MAX_SIZE,

      loadingText: null,
      data: {
        list: [],
        isLoading: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        ARTICLE_DLB_TYPE_CODE: "044-003",
        userId: "",
        sortProp: "createTm",
        sortOrder: "desc"
      },
      form: {
        startTm: null,
        endTm: null,
        keyword: ""
      },
      fileIconType: {
        ppt: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        word: "icon-file-word-fill",
        pdf: "icon-PDF"
      },
      dialog: {
        isShow: false,
        caseId: null,
        editFlag: "view",
        postCode: null,
        postTpCode: "",
        status: ""
      },
      iconStyle: { "font-size": "30px", color: "rgb(79,161,243)" },
      dialogVisible: false,
      border: true,
      postCreateVisible: false,
      postDetailVisible: false,
      postUpdateVisible: false,
      postApproveVisible: false,
      //动态共享的基础路径
      baseUrl: "/eims-api/caseShare/create",
      baseUrlUpdate: "/eims-api/caseShare/update",
      baseUrlDetail: "/eims-api/caseShare/detail"
    };
  },
  computed: {
    ...mapState({
      deptPower: state => state.userPowerStore.deptPower,
      oldKeyword: state => state.caseShareModule.oldKeyword,
      oldStartTm: state => state.caseShareModule.oldStartTm,
      oldEndTm: state => state.caseShareModule.oldEndTm,
      oldPageSize: state => state.caseShareModule.oldPageSize,
      oldPageNum: state => state.caseShareModule.oldPageNum
    }),
    tableData() {
      return this.data.list.slice(
        (this.data.pageNum - 1) * this.data.pageSize,
        this.data.pageNum * this.data.pageSize
      );
    },
    tableColumns() {
      let arr = [];
      if (
        this.showDataType === "-1" ||
        this.showDataType === "0" ||
        this.showDataType === "2"
      ) {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布人",
            prop: "userName",
            align: "left",
            width: "150",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true,
            hidden: !this.deptPower && this.showDataType === "-1"
          },
          {
            label: "大小",
            prop: "totalAttaSize",
            align: "left",
            width: "100",
            showSlot: true,
            sortable: true
          }
        ];
      } else if (this.showDataType === "1") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "申请时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "申请人",
            prop: "userName",
            align: "left",
            width: "150",
            sortable: true
          },
          {
            label: "单位",
            prop: "departmentName",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "100",
            showSlot: true,
            sortable: true
          }
        ];
      }
      return arr;
    }
  },
  watch: {
    "data.list.length": {
      handler(newVal, oldVal) {
        if (newVal < oldVal) {
          if (oldVal === 1) {
            if (this.data.pageNum !== 1) {
              this.handlePageChange(this.data.pageNum - 1);
            } else {
              this.handlePageChange(1);
            }
          }
        }
      }
    }
  },

  created() {
    this.form.keyword = this.oldKeyword;
    this.form.startTm = this.oldStartTm;
    this.form.endTm = this.oldEndTm;
    this.form.pageSzie = this.oldPageSize;
    this.form.pageNum = this.oldPageNum;
  },
  mounted() {
    this.initPage();
    this.queryData();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.query.flag) {
      this.showDataType = to.query.flag;
    }
    this.queryData();
  },
  filters: {
    //取截单元,单位
    fileSizeUnit: arg => {
      if (parseFloat(arg) / (1024 * 1024) > 1) {
        return (parseFloat(arg) / (1024 * 1024)).toFixed(2) + "MB";
      } else if (parseFloat(arg) / 1024 > 1) {
        return (parseFloat(arg) / 1024).toFixed(2) + "KB";
      } else {
        return (arg ? (parseFloat(arg) / 1024).toFixed(2) : "0") + "KB";
      }
    },
    fileIcon: function(arg, this_) {
      if (arg && arg.length > 0) {
        let type = arg[0].attachmentOriginalName.substring(
          arg[0].attachmentOriginalName.lastIndexOf(".") + 1
        );
        return this_.fileIconType[type] + " iconfont";
      }
      return "";
    }
  },
  methods: {
    //-1显示全部，0显示自己发布的，1显示未审核的(管理员显示)
    showTypeQuery(type) {
      //点击选择选中不同身份显示的文章
      if (type === "add") {
        this.handleClickAdd();
      } else {
        if (this.showDataType !== type) {
          this.showDataType = type;
          this.data.pageNum = this.$options.data().data.pageNum;
          this.data.list = this.$options.data().data.list;
          this.data.total = this.$options.data().data.total;
          this.$router.push({
            path: this.$route.path,
            query: {
              flag: this.showDataType
            }
          });
        } else {
          this.queryData();
        }
      }
    },
    handleClickAdd() {
      this.postCreateVisible = true;
      this.border = false;
      this.dialog.editFlag = "add";
      this.dialog.isShow = true;
    },
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },

    handlerVisible(flag) {
      this.postCreateVisible = flag;
      this.postDetailVisible = flag;
      this.postUpdateVisible = flag;
    },
    initPage() {
      if (this.$route.query.flag) {
        this.showDataType = this.$route.query.flag;
      } else {
        this.showDataType = "-1";
      }
      if (this.$route.query.code) {
        this.dialog.postCode = this.$route.query.code;
      }
      let url = window.location.href;
      let index = url.indexOf("flag");
      let code = url.indexOf("code");
      if (index != -1 && code != -1) {
        this.caseShareFilePrevExp();
      }
    },
    closeDialog(obj) {
      this.dialog.isShow = false;
      this.dialog.editFlag = "view";
      this.dialog.caseId = null;
      if (obj == "1") {
        let _this = this;
        this.data.isLoading = true;
        http
          .post(window.config.api.baseUrl + "/eims-api/caseShare/list", {
            token: cookie.getCookie("token"),
            data: {
              pageNum: _this.data.pageNum,
              pageSize: _this.data.pageSize,
              startTm: _this.form.startTm
                ? this.moment(_this.form.startTm).format("YYYY-MM-DD")
                : null,
              endTm: _this.form.endTm
                ? this.moment(_this.form.endTm).format("YYYY-MM-DD")
                : null,
              keyword: _this.form.keyword
            }
          })
          .then(function(response) {
            let data = response.data.data;
            _this.data.list = data.list;
            _this.data.total = data.total;
          })
          .finally(() => {
            _this.data.isLoading = false;
          });
      }
    },
    handleClickSearch(form) {
      this.form = { ...this.form, ...form };
      this.data.pageNum = 1;
      this.queryData();
    },
    back() {
      this.$router.push({ path: "/dashboard" });
    },
    //分页
    handlePageChange(val) {
      this.data.pageNum = val;
      // this.queryData();
    },

    handleSizeChange(val) {
      this.data.pageSize = val;
      // this.queryData();
    },

    queryData() {
      if (this.showDataType === "-1") {
        if (this.deptPower) {
          this.queryOneself(false);
        } else {
          this.queryAllPublish();
        }
      } else if (this.showDataType === "0") {
        this.queryOneself(true);
      } else if (this.showDataType === "1") {
        if (this.deptPower) {
          this.queryUnApprove();
        }
      } else if (this.showDataType === "2") {
        this.queryOneself(false);
      }
    },
    //查询已发布并审核通过的数据
    queryAllPublish() {
      this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/caseShare/list", {
          token: cookie.getCookie("token"),
          data: {
            // pageNum: this.data.pageNum,
            // pageSize: this.data.pageSize,
            createUserId: this.userId,
            keyword: this.form.keyword,
            startTm: this.form.startTm
              ? this.moment(this.form.startTm).format("YYYY-MM-DD")
              : null,
            endTm: this.form.endTm
              ? this.moment(this.form.endTm).format("YYYY-MM-DD")
              : null,
            showDataType: this.showDataType
            // sortProp: this.data.sortProp,
            // sortOrder: this.data.sortOrder,
          }
        })
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
          }
        })
        .finally(() => {
          this.data.isLoading = false;
        });
    },
    queryOneself(flag) {
      let _this = this;
      this.$store.dispatch("saveFindParam", {
        pageNum: _this.data.pageNum,
        pageSize: _this.data.pageSize,
        startTm: _this.form.startTm
          ? this.moment(_this.form.startTm).format("YYYY-MM-DD")
          : null,
        endTm: _this.form.endTm
          ? this.moment(_this.form.endTm).format("YYYY-MM-DD")
          : null,
        keyword: _this.form.keyword
      });
      this.data.isLoading = true;
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/list",
          {
            token: cookie.getCookie("token"),
            data: {
              // pageNum: _this.data.pageNum,
              // pageSize: _this.data.pageSize,
              startTm: _this.form.startTm
                ? this.moment(_this.form.startTm).format("YYYY-MM-DD")
                : null,
              endTm: _this.form.endTm
                ? this.moment(_this.form.endTm).format("YYYY-MM-DD")
                : null,
              timeRange: [_this.form.startTm, _this.form.endTm],
              keyword: _this.form.keyword,
              status: "-1",
              mySelf: flag,
              postTpCode: this.data.ARTICLE_DLB_TYPE_CODE,
              sortProp: _this.data.sortProp,
              sortOrder: _this.data.sortOrder
            }
          }
        )
        .then(function(response) {
          let data = response.data.data;
          _this.data.list = data.approves;
          _this.data.total = data.total;
          _this.data.userId = data.userId;
        })
        .finally(() => {
          _this.data.isLoading = false;
        });
    },
    //查询所有未审核的数据
    queryUnApprove() {
      this.data.isLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // pageNum: this.data.pageNum,
          // pageSize: this.data.pageSize,
          keyword: this.form.keyword,
          timeRange: [
            this.form.startTm
              ? this.moment(this.form.startTm).format("YYYY-MM-DD")
              : null,
            this.form.endTm
              ? this.moment(this.form.endTm).format("YYYY-MM-DD")
              : null
          ],
          status: "0",
          tpCode: this.data.ARTICLE_DLB_TYPE_CODE
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/share/approve/findApproveList",
          obj
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
            this.data.userId = value.data.data.userId;
          }
        })
        .finally(() => {
          this.data.isLoading = false;
        });
    },
    //编辑动态共享的信息
    handleEditCaseShare(row) {
      if (this.showDataType === "-1") {
        this.baseUrlDetail = "/eims-api/caseShare/detail";
        // this.baseUrlUpdate= '/eims-api/caseShare/update'
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        this.baseUrlDetail = "/eims-api/user/personal/article/detail";
        if (row.status == 1) {
          this.baseUrlUpdate = "/eims-api/caseShare/update";
        } else {
          this.baseUrlUpdate = "/eims-api/user/personal/article/update";
        }
      } else if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
      }

      this.border = false;
      this.dialog.editFlag = "update";
      this.dialog.postCode = row.postCode;
      this.dialog.postTpCode = row.postTpCode;
      this.dialog.status = row.status;
      this.dialog.caseId = Number(row.id);
      this.postUpdateVisible = true;
    },
    //查看
    caseShareFilePrev(row) {
      if (this.showDataType === "-1") {
        if (row.status == "1") {
          this.$store.dispatch("findCaseShareDetail", {
            postCode: row.postCode
          });
          this.$store.dispatch("saveFindParam", {
            pageNum: this.data.pageNum,
            pageSize: this.data.pageSize,
            startTm: this.form.startTm,
            endTm: this.form.endTm,
            keyword: this.form.keyword
          });
          this.$router.push({
            path: "view"
          });
        } else {
          if (row.status == 0 || row.status == 3 || row.status == 2) {
            row.isDraft = 1;
          }
          this.$store.dispatch("findCaseShareDetail", {
            postCode: row.postCode,
            isDraft: row.isDraft,
            postTpCode: row.postTpCode
          });
          this.$store.dispatch("saveFindParam", {
            pageNum: this.data.pageNum,
            pageSize: this.data.pageSize,
            startTm: this.form.startTm,
            endTm: this.form.endTm,
            keyword: this.form.keyword
          });
          this.$router.push({
            path: "view"
          });
        }
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        if (row.status == 0 || row.status == 3 || row.status == 2) {
          row.isDraft = 1;
        }
        this.$store.dispatch("findCaseShareDetail", {
          postCode: row.postCode,
          isDraft: row.isDraft,
          postTpCode: row.postTpCode
        });
        this.$store.dispatch("saveFindParam", {
          pageNum: this.data.pageNum,
          pageSize: this.data.pageSize,
          startTm: this.form.startTm,
          endTm: this.form.endTm,
          keyword: this.form.keyword
        });
        this.$router.push({
          path: "view"
        });
      } else if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
        this.postApproveVisible = true;
      }

      this.border = true;
      this.dialog.editFlag = "view";
      this.dialog.status = row.status;
      this.dialog.postCode = row.postCode;
      // this.dialog.isShow = true;
    },
    caseShareFilePrevExp() {
      if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
        this.postApproveVisible = true;
      }
      this.border = true;
      this.dialog.editFlag = "view";
    },
    caseShareDelete(row) {
      let that = this;
      that
        .$confirm("确定将" + row.postTitle + "删除？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (this.showDataType === "-1") {
            // this.deleteCaseShareId(row)
          } else if (this.showDataType === "0" || this.showDataType === "2") {
            this.deleteArticle(row);
          } else if (this.showDataType === "1") {
            // this.baseUrlDetail = '/eims-api/share/approve/findById'
          }
        })
        .catch(() => {});
    },
    deleteArticle(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          postCode: row.postCode,
          postTpCode: row.postTpCode,
          status: row.status
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/delete",
          obj
        )
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("文章信息删除成功");
          }
        })
        .finally(() => {
          this.queryData();
        });
    },

    // 排序
    sort_change(column) {
      this.data.pageNum = 1;
      this.data.sortProp = column.prop;
      this.data.sortOrder = column.order;

      this.data.list = this.data.list.sort((a, b) => {
        if (column.order === "descending") {
          return this.SortString(a[column.prop], b[column.prop], -1);
        } else if (column.order === "ascending") {
          return this.SortString(a[column.prop], b[column.prop], 1);
        }
        return 0;
      });
    },
    SortString(a, b, sortOrder) {
      if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b) * sortOrder;
      } else if (typeof a === "number" && typeof b === "number") {
        return (a - b) * sortOrder;
      } else if (a instanceof Date && b instanceof Date) {
        return (a - b) * sortOrder;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.case-share-list {
  margin: 20px;
  height: calc(100vh - 109px);
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  .container-body {
    padding: 10px;
    .table-card {
      margin: 20px 0;
    }
    .page {
      float: right;
    }
    .eims-button {
      font-size: 16px;
      color: #409eff;
      border-color: transparent;
      background: transparent;
      white-space: nowrap;
      &:focus {
        outline: none;
      }
    }
  }
}

i.icon-file-ppt-fill {
  color: #ff7082;
  font-size: 40px;
}
i.icon-file-word-fill {
  color: #008dfa;
  font-size: 40px;
}

i.icon-PDF {
  color: #eb5e5e;
  font-size: 40px;
}
i.icon-file-excel-fill {
  color: #00c090;
  font-size: 40px;
}

/deep/ .el-table .cell {
  line-height: unset;
}
/deep/ .el-date-editor .el-range-separator {
  z-index: 2;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f3fdff;
}
</style>



// WEBPACK FOOTER //
// src/pages/article/CaseShareList.vue